module.exports = __webpack_public_path__ + "static/media/Scroll_Buttons@3x.83b7e247.png";